// src/components/selfServeEntitlements/buddyAccounts.js
import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material";

const BuddyAccountsComponent = ({ buddyAccounts, selectedBuddy, setSelectedBuddy }) => {
  if (!buddyAccounts || buddyAccounts.length === 0) {
    return <Typography color="text.secondary">No buddy accounts found.</Typography>;
  }

  return (
    <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
      <InputLabel id="buddy-select-label">Select a Buddy Account</InputLabel>
      <Select
        labelId="buddy-select-label"
        id="buddy-select"
        value={selectedBuddy || ""}
        onChange={(e) => setSelectedBuddy(e.target.value)}
        label="Select a Buddy Account"
      >
        {buddyAccounts.map((account) => (
          <MenuItem key={account.company._id} value={account.company._id}>
            {account.company.name} ({account.companyMembership.role})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BuddyAccountsComponent;
